import styled from 'styled-components';

export const Container = styled.header`
  height: 100vh;
  color: ${props => props.theme.white};
  font-weight: 200;
  display: grid;
  grid-template-rows: 75px 1fr;
  align-items: center;
  gap: 15px;
  background-image: url('/images/background-header.png');
  background-size: cover;
  background-color: ${props => props.theme.darkGray};
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;

  @media (max-width: 1000px) {
    width: 100%;
    padding: 10px 0;
    position: fixed;
    background: ${props => props.theme.darkGray};
    z-index: 100;
  }
`;

export const MenuContainer = styled.div`
  display: grid;
  justify-content: end;
`;

export const MenuDesk = styled.menu`
  display: none;

  @media (min-width: 1000px) {
    height: 30px;
    font-size: 20px;
    display: grid;
    justify-content: end;
    grid-template-columns: 57px 102px 85px 127px 75px;
    gap: 30px;
    margin: 10px 15% 0 0;
    padding: 0;

    a {
      color: white;
      transition: transform .5s;
    }

    a:hover {
      transform: scale(1.2);
    }
  }
`;


export const MenuTableMobile = styled.menu`
  display: none;

  @media (max-width: 1000px) {
    width: 2em
    display: grid;
    justify-self: end;
    padding: 0;
    margin: 0 35px;

    i {
      font-size: 2rem;
      cursor: pointer;
      transition: transform .5s;
    }

    a {
      color: white;
      transition: transform .5s;
    }

    .container-menu-expanded {
      width: 300px;
      height: 100vh;
      position: fixed;
      top: 0;
      right: 0;
      background: #323131;
      z-index: 100;
    }

    .container-menu-expanded p {
      font-size: 2rem;
      font-weight: bold;
      margin: 0;
      position: absolute;
      right: 35px;
      top: 20px;
      cursor: pointer;
      transition: transform .5s;
    }

    .container-menu-expanded div {
      width: 200px;
      font-size: 23px;
      display: grid;
      gap: 5px;
      margin: 25px 35px;
    }

    p:hover,
    i:hover {
      opacity: .6;
    }

    ul {
      margin: 20px 0;
      gap: 20px;
    }

    ul li {
      width: 35px;
      height: 35px;
    }
  }
`;

export const Name = styled.div`
  font-family: -apple-system, BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen',
    'Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue', sans-serif;
  display: grid;
  align-self: start;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 20vh;
  
  h1 {
    font-size: 5vw;
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 2vw;
    opacity: 0.7;
  }

  @media (max-width: 1000px) {
    margin-top: 35vh;

    h1 {
      font-size: 6vw;
    }

    p {
      font-size: 2.5vw;
    }
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 9vw;
    }

    p {
      font-size: 4vw;
    }
  }
`;
